import React from "react";
import "./ConfirmModal.css";
import Button from "../reusable-button/Button";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="confirm-modal-container">
        <h2 className="confirm-modal-title">{title}</h2>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          {/* <ReusableButton label={cancelText} onClick={onCancel} variant="outlined" /> */}
          <Button label={cancelText} onClick={onCancel} variant="outlined" />
          <Button label={confirmText} onClick={onConfirm} variant="solid" />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
